import { render, staticRenderFns } from "./consultForm.vue?vue&type=template&id=39ddd088&scoped=true&"
import script from "./consultForm.vue?vue&type=script&lang=js&"
export * from "./consultForm.vue?vue&type=script&lang=js&"
import style0 from "./consultForm.vue?vue&type=style&index=0&id=39ddd088&lang=scss&scoped=true&"
import style1 from "./consultForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ddd088",
  null
  
)

export default component.exports